import { normalizeLocale } from 'portfolio-shared/util/addLocales';

const SET_LOCALE = 'client/intl/SET_LOCALE';
const SET_MESSAGES = 'client/intl/SET_MESSAGES';

const initialState = {
  locale: normalizeLocale(navigator.language),
  messages: {},
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOCALE:
      return { ...state, locale: action.payload };

    case SET_MESSAGES:
      return { ...state, messages: action.payload };

    default:
      return state;
  }
}

function setLocale(locale) {
  return {
    type: SET_LOCALE,
    payload: locale,
  };
}

function setMessages(messages) {
  return {
    type: SET_MESSAGES,
    payload: messages,
  };
}

const actions = {
  setLocale,
  setMessages,
};

export { actions };
export default reducer;



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/intlReducer.js